import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'

function imgUrl({ cloud, filename, width, quality, ext }) {
	return `https://res.cloudinary.com/${cloud}/image/upload/q_${quality},w_${width}/${filename}.${ext}`
}

function srcset({ cloud, filename, widths, quality, ext }) {
	return _.map(
		widths,
		width => `${imgUrl({ cloud, filename, width, quality, ext })} ${width}w`
	).join(',')
}

export default function CloudinaryPicSet(props) {
	const {
		cloud,
		alt,
		filename,
		ext,
		defaultWidth,
		widths,
		sizes,
		// qualityWebP,
		qualityJpg
	} = props
	const propExtras = _.pickBy(props, (v, k) => !_.has(CloudinaryPicSet.propTypes, k))

	const defaultSrc = imgUrl({
		cloud,
		filename,
		width: defaultWidth,
		quality: qualityJpg,
		ext
	})
    // 2018-11-10 Cloudinary wasn't giving back webp's for some reason on a new upload -- just hacking around that as site not heavy traffic
	// const sourceSrcSet = srcset({
	// 	cloud,
	// 	filename,
	// 	widths,
	// 	quality: qualityWebP,
	// 	ext: 'webp'
	// })
    // <source type="image/webp" srcSet={sourceSrcSet} sizes={sizes} />

	const imgSrcSet = srcset({ cloud, filename, widths, quality: qualityJpg, ext })

	return (
		<picture {...propExtras}>
			<img alt={alt} src={defaultSrc} srcSet={imgSrcSet} sizes={sizes} />
		</picture>
	)
}
CloudinaryPicSet.propTypes = {
	alt: PropTypes.string.isRequired,
	cloud: PropTypes.string.isRequired,
	defaultWidth: PropTypes.number.isRequired,
	ext: PropTypes.string.isRequired,
	filename: PropTypes.string.isRequired,
	// qualityWebP: PropTypes.number.isRequired,
	qualityJpg: PropTypes.number.isRequired,
	sizes: PropTypes.string.isRequired,
	widths: PropTypes.arrayOf(PropTypes.number).isRequired
}
CloudinaryPicSet.defaultProps = {
	cloud: 'zinid',
	// qualityWebP: 50,
	qualityJpg: 65,
	sizes: '100vw'
}



// WEBPACK FOOTER //
// ./src/components/CloudinaryPicSet.js